import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "../lib/supabase";
import { TerminalLine } from "../components/terminal/TerminalLine";

export function LoginPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    supabase.auth.getSession().then(({ data }) => {
      if (data.session) navigate("/", { replace: true });
    });
  }, [navigate]);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true);
    setErr(null);
    const { error } = await supabase.auth.signInWithPassword({ email, password });
    setBusy(false);
    if (error) {
      setErr(error.message);
      return;
    }
    navigate("/", { replace: true });
  }

  const envMissing = !import.meta.env.VITE_SUPABASE_URL || !import.meta.env.VITE_SUPABASE_ANON_KEY;

  return (
    <div className="shukan-shell">
      <div className="shukan-stdout" style={{ display: "flex", flexDirection: "column", gap: "1.25rem", justifyContent: "center", minHeight: "70vh" }}>
        <TerminalLine prompt>shukan login</TerminalLine>
        <TerminalLine dim>$ single-user. no signup. credentials only.</TerminalLine>

        {envMissing ? (
          <div style={{ border: "1px dashed var(--danger)", padding: "0.75rem", maxWidth: "24rem", fontSize: "0.8rem" }}>
            <TerminalLine accent>! CONFIGURATION REQUIRED</TerminalLine>
            <p style={{ margin: "0.5rem 0 0 0", color: "var(--fg-dim)", lineHeight: 1.4 }}>
              Supabase environment variables are missing. Please create a file at <strong>apps/web/.env</strong> containing:
            </p>
            <pre style={{ margin: "0.5rem 0 0 0", color: "var(--danger)", background: "rgba(255, 0, 0, 0.05)", padding: "0.4rem", overflowX: "auto" }}>
{`VITE_API_URL=http://localhost:8787
VITE_SUPABASE_URL=https://your-project.supabase.co
VITE_SUPABASE_ANON_KEY=your-anon-key`}
            </pre>
          </div>
        ) : null}

        <form onSubmit={submit} style={{ display: "flex", flexDirection: "column", gap: "0.75rem", maxWidth: "20rem" }}>
          <label style={{ fontSize: "0.75rem", color: "var(--fg-dim)" }} htmlFor="email">email</label>
          <input
            id="email"
            type="email"
            autoComplete="email"
            className="shukan-input"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <label style={{ fontSize: "0.75rem", color: "var(--fg-dim)" }} htmlFor="password">password</label>
          <input
            id="password"
            type="password"
            autoComplete="current-password"
            className="shukan-input"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />

          <button type="submit" className="shukan-btn shukan-btn-primary" disabled={busy || envMissing} style={{ marginTop: "0.5rem" }}>
            {busy ? "...authenticating" : "$ auth.login"}
          </button>

          {err ? (
            <TerminalLine accent>! {err}</TerminalLine>
          ) : null}
        </form>
      </div>
    </div>
  );
}
